import { useAsync } from "@/shared/hooks/HookBase";
import { useCallback } from "react";
import type IPlanService from "../contracts/IPlanService";
import PlanService from "../services/PlanService";
import type Plan from "../models/Plan";
import type Page from "@/shared/models/Page";
import type PageRequest from "@/shared/models/PageRequest";

const planService: IPlanService = new PlanService();

export function usePlans() {
  const { loading, error, execute } = useAsync();

  const getAllPlans = useCallback(
    async (pageRequest: PageRequest): Promise<Page<Plan> | void> => {
      return await execute(() => planService.getAllPlans(pageRequest));
    },
    [execute],
  );

  const getPlan = useCallback(
    async (id: string) => {
      return await execute(() => planService.getPlan(id));
    },
    [execute],
  );

  const createPlan = useCallback(
    async (plan: Omit<Plan, "id">) => {
      return await execute(() => planService.createPlan(plan), { successMessage: "Plan creado correctamente" });
    },
    [execute],
  );

  const updatePlan = useCallback(
    async (id: string, plan: Partial<Plan>) => {
      return await execute(() => planService.updatePlan(id, plan), { successMessage: "Plan actualizado correctamente" });
    },
    [execute],
  );

  const deletePlan = useCallback(
    async (id: string) => {
      return await execute(() => planService.deletePlan(id), { successMessage: "Plan eliminado correctamente" });
    },
    [execute],
  );

  return {
    loading,
    error,
    getAllPlans,
    getPlan,
    createPlan,
    updatePlan,
    deletePlan,
  };
}
